import CityServicePage from "@/pages/city-service/CityServicePage";
import { torontoPoolHeater } from "@/mocks/cityServiceData";
export default function Page() { return <CityServicePage config={torontoPoolHeater} />; }
